var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4280",
    "data-name": "Path 4280",
    d: "M23.084-13.085l-2.245-1.056a.6.6,0,0,0-.66.108l-3.4,3.181a.6.6,0,0,0-.19.438.6.6,0,0,0,.19.438l3.445,3.217a.6.6,0,0,0,.66.108l2.2-1.008a3,3,0,0,0,1.731-2.719A3,3,0,0,0,23.084-13.1Z",
    transform: "translate(-16.592 14.195)",
    fill: "#4b5474"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4282",
    "data-name": "Path 4282",
    d: "M3.013,7.23,16.362-6.812a.714.714,0,0,0,.19-.491.714.714,0,0,0-.19-.491L2.881-21.77a2.8,2.8,0,0,0-.888.4A3.466,3.466,0,0,0,.6-18.525V3.958A3.466,3.466,0,0,0,1.992,6.8,2.787,2.787,0,0,0,3.013,7.23Z",
    transform: "translate(-0.6 21.77)",
    fill: "#4b5474"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4284",
    "data-name": "Path 4284",
    d: "M20.233-13.161a.6.6,0,0,0,.184-.534.6.6,0,0,0-.34-.451L5.6-21,16.74-10.7a.6.6,0,0,0,.816,0Z",
    transform: "translate(-5.6 21)",
    fill: "#4b5474"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4286",
    "data-name": "Path 4286",
    d: "M17.528-9.663a.6.6,0,0,0-.816,0L5.8.576,20.121-6.146a.6.6,0,0,0,.34-.451.6.6,0,0,0-.184-.534Z",
    transform: "translate(-5.8 9.823)",
    fill: "#4b5474"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5245",
    "data-name": "Group 5245",
    transform: "translate(-0.6 21.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4500",
    "data-name": "Group 4500",
    transform: "translate(22.377 -11.112)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4279",
    "data-name": "Path 4279",
    d: "M11.592-19.2H31.819V.408H11.592Z",
    transform: "translate(-17.594 13.193)",
    fill: "#4b5474"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4501",
    "data-name": "Group 4501",
    transform: "translate(0.6 -21.77)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4281",
    "data-name": "Path 4281",
    d: "M-4.4-26.77H23.556V15.693H-4.4Z",
    transform: "translate(-1.602 20.038)",
    fill: "#4b5474"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4502",
    "data-name": "Group 4502",
    transform: "translate(7.832 -20.846)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4283",
    "data-name": "Path 4283",
    d: "M.6-26H27.429V-3.536H.6Z",
    transform: "translate(-6.602 19.998)",
    fill: "#4b5474"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4503",
    "data-name": "Group 4503",
    transform: "translate(8.105 -4.286)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4285",
    "data-name": "Path 4285",
    d: "M.8-14.823H27.473V7.58H.8Z",
    transform: "translate(-6.802 8.821)",
    fill: "#4b5474"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/googlePlay.41a1c45d05332616edd5b100020d292b.svg";
export { ForwardRef as ReactComponent };